import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import HOC from '../../components/HOC/HOC';
import addjob from '../../css/style.module.css';

import { FaArrowRightLong } from 'react-icons/fa6';
import img2 from '../../assest/loading1.gif';
import { SuccessfullyModal } from '../../components/Modals/Modals';
import { getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import { formatDate } from '../../utils/utils';

const OrderDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  const [searchParams, setSearchParams] = useSearchParams();
const page = parseInt(searchParams.get('page')) || 1;

  // Display wall-clock times as stored (no Asia/Kolkata +5:30 conversion).
  const formatOrderJobTime = timestamp => {
    let date;

    if (timestamp && typeof timestamp.toMillis === 'function') {
      date = new Date(timestamp.toMillis());
    } else if (timestamp instanceof Date) {
      date = timestamp;
    } else if (typeof timestamp === 'string') {
      date = new Date(timestamp);
    } else {
      return 'Invalid Time';
    }

    if (isNaN(date.getTime())) {
      return 'Invalid Time';
    }

    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;

    return `${displayHours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')} ${period}`;
  };

  const fetchCartData = useCallback(async () => {
    await getApi(endPoints.getorderbyid(id), {
      setResponse: response => {
        setData(response?.data);
      },
      setLoading: setLoading,
      errorMsg: 'Failed to fetch data!',
    });
  }, [id]);

  useEffect(() => {
    fetchCartData();
  }, [fetchCartData]);

  const renderSubCategoryDetails = subCat => {
    return (
      <>
        <div className={addjob.addcontactdetails}>
          {subCat.product?.length > 0 &&
            subCat.product.map((product, productIndex) => (
              <>
                <div className={addjob.addjobinputs}>
                  <label>Product Name</label>
                  <input type="text" value={product.productId?.name || ''} readOnly />
                </div>
                <div className={addjob.addjobinputs}>
                  <label>Quantity</label>
                  <input type="text" value={product.quantity || 0} readOnly />
                </div>
                <div className={addjob.addjobinputs}>
                  <label>Price Per Unit</label>
                  <input type="text" value={`₹${product.productId?.price || 0}`} readOnly />
                </div>
                <div className={addjob.addjobinputs}>
                  <label>Product Subtotal</label>
                  <input
                    type="text"
                    value={`₹${product.total || product.quantity * product.productId?.price || 0}`}
                    readOnly
                  />
                </div>
              </>
            ))}
          {subCat.subCategoryId?.name && (
            <div className={addjob.addjobinputs}>
              <label>Subcategory</label>
              <input type="text" value={subCat.subCategoryId?.name || ''} readOnly />
            </div>
          )}
          <div className={addjob.addjobinputs}>
            <label>Start Time</label>
            <input type="text" value={formatOrderJobTime(subCat.fromTime)} readOnly />
          </div>
          <div className={addjob.addjobinputs}>
            <label>End Time</label>
            <input type="text" value={formatOrderJobTime(subCat.toTime)} readOnly />
          </div>
          <div className={addjob.addjobinputs}>
            <label>Working Hours</label>
            <input type="text" value={subCat.totalTime} readOnly />
          </div>
          {subCat.adults && (
            <div className={addjob.addjobinputs}>
              <label>Adults</label>
              <input type="text" value={subCat.adults || 0} readOnly />
            </div>
          )}
          {subCat.kids && (
            <div className={addjob.addjobinputs}>
              <label>Kids</label>
              <input type="text" value={subCat.kids || 0} readOnly />
            </div>
          )}
          {subCat.pax && (
            <div className={addjob.addjobinputs}>
              <label>Pax</label>
              <input type="text" value={subCat.pax || 0} readOnly />
            </div>
          )}
          {subCat.kids && (
            <div className={addjob.addjobinputs}>
              <label>Timing Price</label>
              <input type="text" value={`₹${subCat.price || 0}`} readOnly />
            </div>
          )}
          {subCat.pax && (
            <div className={addjob.addjobinputs}>
              <label>User Price Per Pax</label>
              <input type="text" value={`₹${subCat.price || 0}`} readOnly />
            </div>
          )}
          {subCat.pax && (
            <div className={addjob.addjobinputs}>
              <label>Subtotal</label>
              <input type="text" value={`₹${subCat.price * (subCat.pax || 0)}`} readOnly />
            </div>
          )}
          {subCat.forStaffPrice && (
            <div className={addjob.addjobinputs}>
              <label htmlFor="category">Staff Price Per Pax</label>
              <input type="text" value={'₹' + subCat.forStaffPrice} readOnly />
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <SuccessfullyModal
        show={show}
        handleClose={() => setShow(false)}
        text={'Successfully CheckOut'}
      />
      <div className={addjob.jobmanagementCotainer}>
        <div className={addjob.jobtoppart}>
          <div className={addjob.pagetitle}>
            <h6>
              {data?.user?.firstName} {data?.user?.lastName} Order Details
            </h6>
          </div>
        </div>

        <div className={addjob.addjobcontainer}>
          <div className={addjob.addjobsubcontainer}>
            <div className={addjob.addjobtopic}>
              <h6>Order Details</h6>
            </div>
            {loading ? (
              <div className={addjob.loadingnormal}>
                <img src={img2} alt="Loading" width={100} height={100} />
              </div>
            ) : (
              <>
                <div className={addjob.addcontactdetails}>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="category">Order Created At</label>
                    <input type="text" name="orderdate" value={formatDate(data?.createdAt)} />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="category">Order ID</label>
                    <input type="text" name="orderId" value={data?.orderId} />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="category">Order Status</label>
                    <input type="text" name="orderId" value={data?.jobStatus} />
                  </div>
                </div>
                {data?.jobs?.map((job, jobIndex) => (
                  <div key={job._id || jobIndex}>
                    <div className={addjob.addjobtopic1}>
                      <FaArrowRightLong color="#5A5A5A" />
                      <h6>Job #{jobIndex + 1} Details</h6>
                    </div>
                    <div className={addjob.addcontactdetails}>
                      <div className={addjob.addjobinputs}>
                        <label htmlFor="category">Date</label>
                        <input type="text" value={formatDate(job.date)} readOnly />
                      </div>
                      <div className={addjob.addjobinputs}>
                        <label htmlFor="category">Category</label>
                        <input type="text" value={job.category?.name} readOnly />
                      </div>
                    </div>


                    {job.subCategories?.map((subCat, subIndex) => (
                      <div key={subCat._id || subIndex}>
                        <div className={addjob.addjobtopic1}>
                          <FaArrowRightLong color="#5A5A5A" />
                          <h6>
                            {subCat.product?.length > 0 ? 'Product' : 'Subcategory'} #{subIndex + 1}
                          </h6>
                        </div>
                        {renderSubCategoryDetails(subCat)}
                        {/* <div className={addjob.addcontactdetails}>
                                                    <div className={addjob.addjobinputs}>
                                                        <label>Subcategory</label>
                                                        <input
                                                            type="text"
                                                            value={subCat.subCategoryId?.name || ''}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className={addjob.addjobinputs}>
                                                        <label htmlFor="category">Start Time</label>
                                                        <input
                                                            type="text"
                                                            value={subCat.fromTime?.split("T")[1]?.slice(0, 5) || ""}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className={addjob.addjobinputs}>
                                                        <label htmlFor="category">End Time</label>
                                                        <input
                                                            type="text"
                                                            value={subCat.toTime?.split("T")[1]?.slice(0, 5) || ""}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className={addjob.addjobinputs}>
                                                        <label htmlFor="category">Working Hours</label>
                                                        <input
                                                            type="text"
                                                            value={subCat.totalTime}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className={addjob.addjobinputs}>
                                                        <label htmlFor="category">Number of Pax</label>
                                                        <input
                                                            type="text"
                                                            value={subCat.pax}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className={addjob.addjobinputs}>
                                                        <label htmlFor="category">Price Per Pax</label>
                                                        <input
                                                            type="text"
                                                            value={'₹' + subCat.price}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className={addjob.addjobinputs}>
                                                        <label>Subtotal</label>
                                                        <input
                                                            type="text"
                                                            value={`₹${subCat.total || subCat.price * subCat.pax || 0}`}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className={addjob.addjobinputs}>
                                                        <label htmlFor="category">Staff Price Per Pax</label>
                                                        <input
                                                            type="text"
                                                            value={'₹' + subCat.forStaffPrice}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className={addjob.addjobinputs}>
                                                        <label htmlFor="category">Total Minutes</label>
                                                        <input
                                                            type="text"
                                                            value={subCat.totalMin + " minutes"}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div> */}
                      </div>
                    ))}
                  </div>
                ))}
                <div className={addjob.addjobtopic1}>
                  <FaArrowRightLong color="#5A5A5A" />
                  <h6>Price Details</h6>
                </div>
                <div className={addjob.addcontactdetails}>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="category">Sub Total</label>
                    <input type="text" name="subTotal" value={'₹' + data?.subTotal} readOnly />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="category">GST (18%) Amount</label>
                    <input type="text" name="vat" value={'₹' + data?.vat} readOnly />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="category">Total Amount</label>
                    <input type="text" name="total" value={'₹' + data?.total} readOnly />
                  </div>
                </div>
                <div className={addjob.addjobtopic1}>
                  <FaArrowRightLong color="#5A5A5A" />
                  <h6>Booking Details</h6>
                </div>
                <div className={addjob.addcontactdetails}>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Contact Name</label>
                    <input type="text" value={data?.contactName} readOnly />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Name</label>
                    <input type="text" value={data?.name} readOnly />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Contact Phone</label>
                    <input type="number" value={data?.phone} readOnly />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Country</label>
                    <input type="text" value={data?.country} readOnly />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">State</label>
                    <input type="text" value={data?.state} readOnly />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">City</label>
                    <input type="text" value={data?.city} readOnly />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Address</label>
                    <input type="text" value={data?.address} readOnly />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">PinCode</label>
                    <input type="number" value={data?.pinCode} readOnly />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Parking Access</label>
                    <input type="text" value={data?.parkingAccess} readOnly />
                  </div>

                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Outfits</label>
                    <input type="text" value={data?.outfits} readOnly />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Equipment</label>
                    <input type="text" value={data?.equipment} readOnly />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Mobility</label>
                    <input type="text" value={data?.mobility} readOnly />
                  </div>
                </div>
                <div className={addjob.addjobinputs}>
                  <label htmlFor="">Order Description</label>
                  <textarea value={data?.description} readOnly />
                </div>
                <div className={addjob.addjobtopic1}>
                  <FaArrowRightLong color="#5A5A5A" />
                  <h6>Invoice Details</h6>
                </div>
                <div className={addjob.addcontactdetails}>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Invoice Name</label>
                    <input
                      type="text"
                      placeholder="Enter the invoice name"
                      name="invoiceName"
                      value={data?.invoiceName}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Invoice Address</label>
                    <input
                      type="text"
                      placeholder="Enter the invoice address"
                      name="invoiceAddress"
                      value={data?.invoiceAddress}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Invoice PinCode</label>
                    <input
                      type="number"
                      placeholder="Enter the invoice pinCode"
                      name="invoicePinCode"
                      value={data?.invoicePinCode}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Invoice City</label>
                    <input
                      type="text"
                      placeholder="Enter the invoice city"
                      name="invoiceCity"
                      value={data?.invoiceCity}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Invoice Country</label>
                    <input
                      type="text"
                      placeholder="Enter the invoice country"
                      name="invoiceCountry"
                      value={data?.allBookingId?.invoiceCountry}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Company Registration Number</label>
                    <input
                      type="text"
                      placeholder="Enter the company registration number"
                      name="companyRegistrationNumber"
                      value={data?.companyRegistrationNumber}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Total</label>
                    <input
                      type="text"
                      placeholder="Enter the company registration number"
                      name="total"
                      value={'₹' + data?.total}
                      readOnly
                    />
                  </div>
                </div>
                <div className={addjob.addjobtopic1}>
                  <FaArrowRightLong color="#5A5A5A" />
                  <h6>Staff Assigned Details</h6>
                </div>
                <div className={addjob.addcontactdetails1}>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Assigned Partner ({data?.staff?.length})</label>
                    <ul>
                      {data?.staff?.length === 0 ? (
                        <p>N/A</p>
                      ) : (
                        data?.staff?.map((itme, rowIndex) => (
                          <li key={rowIndex}>
                            {itme.firstName} {itme.lastName}
                          </li>
                        ))
                      )}
                    </ul>
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Accepted Partner ({data?.staffAccepted?.length})</label>
                    <ul>
                      {data?.staffAccepted?.length === 0 ? (
                        <p>N/A</p>
                      ) : (
                        data?.staffAccepted?.map((itme, rowIndex) => (
                          <li key={rowIndex}>
                            {itme.firstName} {itme.lastName}
                          </li>
                        ))
                      )}
                    </ul>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className={addjob.addjobbutton}>
            <div className={addjob.rightbuttons}>
              <button onClick={() => navigate(-1)}>Back</button>
            </div>
            <div className={addjob.rightbuttons}>
              <button
                onClick={() => navigate(`/orders/assignjob/${data?._id}?page=${page}`)}
                style={{ background: '#F05423' }}
                disabled={loading}
              >
                Assing
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HOC(OrderDetails);
